<template>
  <div>
    <div class="md-layout-item md-size-100">
      <md-button class="md-white" v-b-modal.modal-1
        ><md-icon>zoom_in</md-icon>
      </md-button>

      <template :id="id" slot="body">
        <p class="my-4">
          <img width="100%" :src="src" alt="ireal image notice" />
        </p>
      </template>
    </div>
  </div>
</template>
<script>
import componentMixin from "ireal-vue/mixins/component-mixin.js";
//import Modal from "vue-material-kit-pro/src/components/Modal.vue";

export default {
  name: "modal-component",
  mixins: [componentMixin],
  components: {},
  data() {
    return {
      a: this.$store.getters.testParams
    };
  },
  async mounted() {
    this.isModalVisible = this.classicModal;
  },
  watch: {
    classicModal: function(val, oldval) {
      val = oldval ? console.log("change") : console.log("stay");
      this.$refs["testModal"].show();
    }
  },
  computed: {
    img() {
      return this.attributes.img;
    },
    src() {
      return this.attributes.src;
    },
    id() {
      return this.attributes.id ? this.attributes.id : "modal-1";
    }
  },
  methods: {
    classicModalHide() {
      this.classicModal = false;
    },

    showModal() {
      this.$refs["testModal"].show();
    },
    close() {
      this.$emit("close");
    },
    hey() {
      console.log("hey");
      this.$refs["testModal"].show();
    }
  }
};
</script>
<style scoped>
button {
  position: fixed;
  z-index: 999;
}
</style>
